// extracted by mini-css-extract-plugin
export default {"searchIconWrapper":"TimeClock_searchIconWrapper__dNhI7","searchIcon":"TimeClock_searchIcon__penQR","title":"TimeClock_title__9JWrU"};